/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TeamMemberStatus } from './TeamMemberStatus';
import {
    TeamMemberStatusFromJSON,
    TeamMemberStatusFromJSONTyped,
    TeamMemberStatusToJSON,
    TeamMemberStatusToJSONTyped,
} from './TeamMemberStatus';
import type { TeamMemberRole } from './TeamMemberRole';
import {
    TeamMemberRoleFromJSON,
    TeamMemberRoleFromJSONTyped,
    TeamMemberRoleToJSON,
    TeamMemberRoleToJSONTyped,
} from './TeamMemberRole';

/**
 * Roster member as returned by the tournament team endpoints, which are
 * anonymously reachable. Payment DETAIL — the ledger transaction id and the
 * charged amounts — is deliberately absent; only whether a share was settled
 * is exposed.
 * 
 * @export
 * @interface TeamRosterMember
 */
export interface TeamRosterMember {
    /**
     * 
     * @type {string}
     * @memberof TeamRosterMember
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRosterMember
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRosterMember
     */
    avatarUrl?: string;
    /**
     * 
     * @type {TeamMemberRole}
     * @memberof TeamRosterMember
     */
    role?: TeamMemberRole;
    /**
     * 
     * @type {number}
     * @memberof TeamRosterMember
     */
    joinedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof TeamRosterMember
     */
    invitedBy?: string;
    /**
     * 
     * @type {TeamMemberStatus}
     * @memberof TeamRosterMember
     */
    status?: TeamMemberStatus;
    /**
     * The member's in-game name for the tournament's game, snapshotted from pipeline state at team-join time. Used to anchor screenshot score parsing.
     * @type {string}
     * @memberof TeamRosterMember
     */
    playerName?: string;
    /**
     * Whether this member has paid their per-player entry-fee share (PER_PLAYER fee mode only)
     * @type {boolean}
     * @memberof TeamRosterMember
     */
    feePaid?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TeamRosterMember
     */
    feePaidAt?: number;
}



/**
 * Check if a given object implements the TeamRosterMember interface.
 */
export function instanceOfTeamRosterMember(value: object): value is TeamRosterMember {
    return true;
}

export function TeamRosterMemberFromJSON(json: any): TeamRosterMember {
    return TeamRosterMemberFromJSONTyped(json, false);
}

export function TeamRosterMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamRosterMember {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'role': json['role'] == null ? undefined : TeamMemberRoleFromJSON(json['role']),
        'joinedAt': json['joinedAt'] == null ? undefined : json['joinedAt'],
        'invitedBy': json['invitedBy'] == null ? undefined : json['invitedBy'],
        'status': json['status'] == null ? undefined : TeamMemberStatusFromJSON(json['status']),
        'playerName': json['playerName'] == null ? undefined : json['playerName'],
        'feePaid': json['feePaid'] == null ? undefined : json['feePaid'],
        'feePaidAt': json['feePaidAt'] == null ? undefined : json['feePaidAt'],
    };
}

export function TeamRosterMemberToJSON(json: any): TeamRosterMember {
    return TeamRosterMemberToJSONTyped(json, false);
}

export function TeamRosterMemberToJSONTyped(value?: TeamRosterMember | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'displayName': value['displayName'],
        'avatarUrl': value['avatarUrl'],
        'role': TeamMemberRoleToJSON(value['role']),
        'joinedAt': value['joinedAt'],
        'invitedBy': value['invitedBy'],
        'status': TeamMemberStatusToJSON(value['status']),
        'playerName': value['playerName'],
        'feePaid': value['feePaid'],
        'feePaidAt': value['feePaidAt'],
    };
}

